import React from "react";
import {FaLock} from "react-icons/fa";

interface Props {
    message: string;
}

export default function ViewLocked({message}: Props) {
    return (
        <div className="view-locked">
            <FaLock className="view-lock-icon" />
            <span>{message}</span>
        </div>
    );
}